<template>
  <el-dialog title="选择客户" :visible.sync="dialogFormVisible" custom-class="medium-dialog" center :append-to-body="true"
             :close-on-click-modal="false">
    <div class="search-content">
      <el-col :span="24" class="toobar">
        <AutoCustomer :content="customername" :size="''"  @handleSelect="selectExternalDept"></AutoCustomer>
      </el-col>
    </div>
    <el-table
      :data="tableData"
      size="mini" stripe  border
      style="width: 100%;" >
      <el-table-column type="index" width="60" label="序号" align="center">
      </el-table-column>
      <el-table-column
        prop="customerserial"
        label="编码"
        align="left"
        header-align="center"
        width="150" >
      </el-table-column>
      <el-table-column
        prop="customername"
        label="名称"
        align="left"
        header-align="center">
      </el-table-column>
      <el-table-column label="操作" align="center" width="90">
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="handleRemove(scope.$index, scope.row)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer" class="dialog-footer">
    <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleSelect">确 定</el-button>
    </div>
  </el-dialog>


</template>

<script>
  //  import ExternaldeptEdit from './externaldeptEdit';
  import {getListData, deleteData} from '@/api/set/externaldept';
  import {independentDept} from '@/api/set/dept';

  export default {
    name: 'ExternaldeptMulSel',
    data() {
      return {
        msg: '多选客户',
        dialogFormVisible: false,
        tableData: [],
        customername: '',//独立核算
        customerserial:'',
      }
    },
    props: {
      unitgroup: {
        default: 1
      },
    },
    methods: {
      handleRemove(index,row) {
        this.tableData.splice(index, 1);
      },
      handleSelect() {
        this.$emit("afterSelectCode",this.tableData)
        this.dialogFormVisible = false
      },
      selectExternalDept(customerserial, deptname, row) {
        this.customerserial = customerserial;
        this.customername = deptname;
        for(let i in this.tableData){
          if(this.tableData[i].customerserial==customerserial){
            return;
          }
        }
        this.tableData.push({customerserial:customerserial,customername:deptname});
      },
      show() {
        this.dialogFormVisible = true
        this.tableData=[];
        this.customername='';
      },
    },
    mounted() {
    },
    components: {
    }

  }


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/set/externaldept/ExternaldeptMulSel.vue